import { IRegionSpecialPromo } from '../types/specialPromos';

export const PIK_PROMO_REGIONS = [1, 4593];
export const PIK_PROMO: IRegionSpecialPromo = {
  developerId: 9,
  region: -1,
  filterLabel: 'ПИК',
};
